import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Linking Customs Roles
 * !== 세관 역할 연결 화면 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/sysm/sport`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/sysm/sport/lgn`,
    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getUsrInfo: (data: any) => api.get(`${BASE.api}/usr`, { params: comnUtils.toGetParams(data) }),
};

export const SF_SPORT_LGN_SRCH: TFormSchema = {
    id: "form_sportLgnSrch",
    schema: {
        usrId: { type: "text", label: "L_USR_ID", required: true },
        usrTp: { type: "select", label: "L_USR_TP", required: true },
    },
};

export const SF_SPORT_LGN_INFO: TFormSchema = {
    id: "form_sportLgnInfo",
    schema: {
        usrId: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_USR_NM" },
        tin: { type: "text", label: "L_TIN" },
        usrAddr: { type: "text", label: "L_USR_ADDR" },
        telNo: { type: "text", label: "L_TELNO" },
        moblNo: { type: "text", label: "L_MOBL_NO" },
        emlAddr: { type: "text", label: "L_EML_ADDR" },
        usrStatCd: { type: "text", label: "L_USR_STAT_CD" },
        lgnTp: { type: "text", label: "L_LGN_TP" },
        coRppnNm: { type: "text", label: "L_CO_RPPN_NM" },
        coTelNo: { type: "text", label: "L_CO_TELNO" },
        coFaxNo: { type: "text", label: "L_CO_FAX_NO" },
        coAddr: { type: "text", label: "L_CO_ADDR" },
        coEmlAddr: { type: "text", label: "L_CO_EML_ADDR" },
        coNm: { type: "text", label: "L_CO_NM" },
        coTin: { type: "text" },
        cfaTin: { type: "text" },
        cfaUsrYn: { type: "text" },
        inwdCoYn: { type: "text" },
        coRppnYn: { type: "text" },
        orgNm: { type: "text", label: "L_ORG_NM" },
        orgRppnYn: { type: "text", label: "L_ORG_RPPN_YN" },
        orgRppnNm: { type: "text", label: "L_ORG_RPPN_NM" },
        orgTelno: { type: "text", label: "L_ORG_TEL_NO" },
        orgFaxNo: { type: "text", label: "L_ORG_FAX_NO" },
        orgEmlAddr: { type: "text", label: "L_ORG_EML_ADDR" },
        orgPhysAddr: { type: "text", label: "L_ORG_PHYS_ADDR" },
        orgPostAddr: { type: "text", label: "L_ORG_POST_ADDR" },
        orgDeptCd: { type: "text", label: "L_ORG_DEPT_CD" },
        orgDeptNm: { type: "text", label: "L_ORG_DEPT_NM" },
    },
};
